module.exports = __webpack_public_path__ + "static/img/iphone.33686fd3.png";